import {stringUStoISO, dateToUsString} from '../../../../date-converter';

export const buildRentRollRow = function (tenantDataRow) {
    return {
        valueCells: [{ // % of Sq Ft - 0
            editable: false,
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs['current-rr-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[0].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}%`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Start - 1
            editable: false,
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs['current-rr-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[1].value;
                const displayValue = !value ? '-' : `${value.toLocaleString()}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // End - 2
            editable: false,
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs['current-rr-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[2].value;
                const displayValue = !value ? '-' : `${value.toLocaleString()}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Current Annual Rent - 3
            editable: false,
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs['current-rr-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[4].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // PSF - 4
            editable: false,
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs['current-rr-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[5].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Escalation Date - 5
            editable: false,
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const escalationDate = tabs['current-rr-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[10].value;
                const options = tabs['current-rr-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[15].value;
                const endDate = tabs['current-rr-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[2].value;
                let dayAfterEndDate = '';
                if (endDate) {
                    dayAfterEndDate = new Date(`${stringUStoISO(endDate)}T00:00:00`);
                    // add a day to end date
                    dayAfterEndDate = new Date(dayAfterEndDate.getTime() + 1000 * 60 * 60 * 24);
                    dayAfterEndDate = dateToUsString(dayAfterEndDate);
                }
                const value = escalationDate ? escalationDate : (options ? dayAfterEndDate : '');
                const displayValue = !value ? '-' : `${value.toLocaleString()}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Escalation Amount - 6
            editable: false,
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const escalationMonthlyRent = parseFloat(tabs['current-rr-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[11].value);
                const sqFt = parseInt(tabs['current-rr-tab'].tables['general-information'].rows[rowIdentifier].valueCells[2].value);
                const optionRent1 = tabs['current-rr-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[16].value;
                const rent = escalationMonthlyRent ? escalationMonthlyRent : optionRent1;
                const value = parseFloat(rent * 12 / sqFt);
                const displayValue = !value || value < 0 || isNaN(value) ? '-' : `$${value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Options - 7
            editable: false,
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs['current-rr-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[15].value;
                const displayValue = !value ? '-' : `${value.toLocaleString()}`;
                return {internalValue: value, displayValue: displayValue};
            },
        }, { // Lease Type - 8
            unit: '',
            type: 'number',
            editable: false,
            getComputedValue(tabs, rowIdentifier, precomputedValues) {
                const value = tabs['current-reimbursement-tab'].tables['detailed-information'].rows[rowIdentifier].valueCells[1].getComputedValue(tabs, rowIdentifier, precomputedValues).internalValue;
                const displayValue = !value ? '-' : value;
                return {internalValue: value, displayValue: displayValue};
            },
        }]
    }
};

export const rentRoll = {
    hasNamesColumn: false,
    rows: {},
};
